import { render, staticRenderFns } from "./PassengerAvatar.vue?vue&type=template&id=0eac5ac8"
import script from "./PassengerAvatar.vue?vue&type=script&lang=ts"
export * from "./PassengerAvatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports